import * as React from 'react';
import { Colors } from '@origin-digital/style-guide';
import styled from 'styled-components';
import { LG, MD, SM, XL } from '@origin-digital/helper';

interface CardProps {
  children: React.ReactChild;
  image?: string;
}

const AuthCard: React.FC<CardProps> = ({ children, image }) => (
  <Card>
    <AuthCardContent>
      {children}
      {image && <StyledImage src={image} />}
    </AuthCardContent>
  </Card>
);

const StyledImage = styled.img`
  display: none;
  ${MD`
    display: inline;
    position: absolute;
    right: -148px;
    bottom: -45px;
  `}
`;

const Card = styled.div`
  background-color: ${Colors.WHITE};
  border-bottom: 8px solid #f1f1f1;
`;

const AuthCardContent = styled.div`
  border-bottom: 8px solid #f1f1f1;
  padding: 24px 16px;
  ${SM`
   padding: 48px;
  `}
  ${MD`
  `}
  ${LG`
  `}
  ${XL`
  `}
`;

export { Card, AuthCard };
